import React, { useState } from 'react'
import Facebook from '../../../assets/icons/icon-gray-facebook.webp'
import Linkedin from '../../../assets/icons/icon-gray-linkedin.webp'
import Instagram from '../../../assets/icons/icon-gray-instagram.webp'
import Youtube from '../../../assets/icons/icon-gray-youtube.webp'

import { Button } from '../../common'
import { Link } from 'react-router-dom'
import { PerfilInterno } from './PerfilInterno'

import { Accordion } from '../../common'
import IconJourney from '../../../assets/icons/icon_journey_black.webp'
import IconNotific from '../../../assets/icons/icon_notifications.webp'
import IconLogout from '../../../assets/icons/icon_out.svg'
import IconProfile from '../../../assets/icons/icon_profile.webp'
import { useAuth } from '../../../hooks/useAuth'
import { Suspense, useEffect } from 'react'
import SkeletonLoading from '../../common/SkeletonLoading'
import Logo from '../../../assets/glemo-logo.webp'

interface Props {
  showModal: boolean
  closeModal: () => void
}

const listCidades = ['Belo Horizonte - MG', 'Belvedere, Belo Horizonte - MG', 'Belém PA']

export function ModalPerfil({ showModal, closeModal }: Props) {
  const [showModalFilter, setShowModalFilter] = useState(false)
  const [valueInput, setValueInput] = useState('')
  const [listFilter, setListFilter] = useState(listCidades)
  const [showProfileIntern, setShowProfileIntern] = useState(false)
  const auth = useAuth()
  const userLogin = Array.isArray(auth.loginUser) ? auth.loginUser[0] : auth.loginUser

  const handleSignout = () => {
    auth.logout()
  }

  useEffect(() => {
    const signoutPerfilInterno = document.querySelector('#signoutPerfilInterno') as HTMLElement
    signoutPerfilInterno?.addEventListener('click', handleSignout)
  }, [handleSignout])

  useEffect(() => {
    if (valueInput != undefined && valueInput.replace(' ', '') != '') {
      setListFilter([])
      const newList = listCidades.filter((element) => element.includes(valueInput))
      setListFilter(newList)
    } else {
      setListFilter(listCidades)
    }
  }, [valueInput])

  const handleChangeModal = () => {
    setShowProfileIntern(!showProfileIntern)
  }

  useEffect(() => {
    const loginModalPerfil = document.querySelector('#loginModalPerfil') as HTMLElement
    loginModalPerfil?.addEventListener('click', handleChangeModal)
  }, [handleChangeModal])

  return (
    <>
      {showModal && !showProfileIntern ? (
        <>
          <div className="modal-perfil justify-center fixed z-[998] w-full h-full top-0">
            <div className="relative w-full h-full">
              <div className="container-modal h-full border-0 relative flex flex-col bg-white outline-none focus:outline-none p-4 overflow-y-auto w-full">
                <>
                  {/* <div className="">
                  <Suspense fallback={<SkeletonLoading/>}><img loading='lazy' alt="Logo do anunciante" src={Logo} className="w-[125px] max-w-full m-auto" /></Suspense>
                  <h6 className="font-semibold text-center text-lg text-[#4D4D4D]">
                    Acesse sua conta para favoritar imóveis e entrar em contato com anunciantes!
                  </h6>
                  <Button
                    variant="orange"
                    className="font-bold text-xl m-auto w-[150px] max-w-full my-4"
                    id='loginModalPerfil'
                  >
                    LOGIN
                  </Button>
                  <div>
                    <h6 className="text-lg text-[#666666] text-center">
                      Novo no glemO?{' '}
                      <span className="text-[#F15C00] font-bold">
                        <a href={'/registrar'}>Cadastre-se!</a>
                      </span>
                    </h6>
                    <hr className="border-2 text-[#F15C00] mt-4 w-64 m-auto" />
                  </div>
                </div>
                <ul className='gap-4 grid'>
                  <li>
                    <div className="">
                      <Accordion.Root collapsible type="single" className="shadow-none bg-white p-0 m-0">
                        <Accordion.Item value="item-1 bg-white p-0 m-0">
                          <Accordion.Trigger className="text-[#555555] text-xl font-bold p-0 m-0">
                            Central de Ajuda
                          </Accordion.Trigger>
                          <Accordion.Content>
                            <div className="text-[#555555] text-lg">
                              <h6>Entre em contato</h6>
                              <ul>
                                <li>
                                  <a href={'/'}>(31) 99999-9999</a>
                                </li>
                                <li>
                                  <a href={'/'}>suporte@glemo.com</a>
                                </li>
                              </ul>
                            </div>
                          </Accordion.Content>
                        </Accordion.Item>
                      </Accordion.Root>
                    </div>
                  </li>
                  <li className='text-[#555555] text-xl font-bold'>
                    <a href={"/"}>Imóveis visualizados</a>
                  </li>
                  <li className='text-[#555555] text-xl font-bold'>
                    <a href={"/termos-de-uso"} className='underline underline-offset-4'>Termos de uso</a>
                  </li>
                  <li className='text-[#555555] text-xl font-bold'>
                    <a href={"/"} className='underline underline-offset-4'>Política de privacidade</a>
                  </li>
                </ul>
                <div>
                  <h6 className='text-center text-[#555555] font-bold text-2xl mt-10'>glemO nas redes</h6>
                  <div className='grid grid-cols-4 mt-8'>
                    <div>
                      <Suspense fallback={<SkeletonLoading/>}><img loading='lazy' alt="Logo Facebook" src={Facebook} className='m-auto'/></Suspense>
                    </div>
                    <div>
                      <Suspense fallback={<SkeletonLoading/>}><img loading='lazy' alt="Logo Linkedin" src={Linkedin} className='m-auto'/></Suspense>
                    </div>
                    <div>
                      <Suspense fallback={<SkeletonLoading/>}><img loading='lazy' alt="Logo Instagram" src={Instagram} className='m-auto'/></Suspense>
                    </div>
                    <div>
                      <Suspense fallback={<SkeletonLoading/>}><img loading='lazy' alt="Logo Youtube" src={Youtube} className='m-auto'/></Suspense>
                    </div>
                  </div>
                </div> */}
                </>
                <>
                  <div className="mt-5 mb-10">
                    <div className="flex justify-between">
                      <div className=" text-glemo-blue flex align-middle">
                        {/* <X size={25} className="text-glemo-blue" id='closeModalMenuMobile'></X> */}
                        <svg
                          width="17"
                          onClick={closeModal}
                          height="16"
                          viewBox="0 0 17 16"
                          fill="none"
                          className="inline-block mt-4"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M16.0833 7H3.91334L9.50334 1.41L8.08334 0L0.0833435 8L8.08334 16L9.49334 14.59L3.91334 9H16.0833V7Z"
                            fill="#F15C00"
                          />
                        </svg>
                      </div>
                      <div className="m-auto">
                        <Suspense fallback={<SkeletonLoading />}>
                          <img alt="Logo do Glemo" src={Logo} className="w-[130px] max-w-full" />
                        </Suspense>
                      </div>
                      <div></div>
                    </div>
                    <div className="mt-10">
                      <h6 className="text-2xl font-bold text-[#4D4D4D] text-center">
                        Olá, {userLogin.User?.Claims[3].Value}
                      </h6>
                      <hr className="border-2 text-[#F15C00] mt-4 mx-10 m-auto" />
                    </div>
                  </div>
                  <ul className="gap-4 grid w-full m-auto mt-10 px-10">
                    <li>
                      <div className="">
                        <Accordion.Root
                          collapsible
                          type="single"
                          className="shadow-none bg-white p-0 m-0"
                        >
                          <Accordion.Item value="item-1 bg-white p-0 m-0">
                            <Accordion.Trigger
                              classNameIconArrow="absolute right-0 me-12"
                              hiddenJustifyBetween
                              hiddenPaddingX
                              className="text-[#18181B] text-xl font-semibold p-0 m-0"
                            >
                              <Suspense fallback={<SkeletonLoading />}>
                                <img alt="Icon Profile" src={IconProfile} className="me-4" />
                              </Suspense>
                              Minha conta
                            </Accordion.Trigger>
                            <Accordion.Content>
                              <div className="text-[#555555] text-lg ">
                                <ul>
                                  <li>
                                    <a href={'/perfil/dados-cadastrais'}>Dados Cadastrais</a>
                                  </li>
                                  <li>
                                    <a href={'/perfil/privacidade'}>Privacidade e segurança</a>
                                  </li>
                                </ul>
                              </div>
                            </Accordion.Content>
                          </Accordion.Item>
                        </Accordion.Root>
                      </div>
                    </li>
                    <li className="text-[#18181B] text-xl font-bold">
                      <a href={'/perfil/minhas-jornadas'}>
                        <Suspense fallback={<SkeletonLoading />}>
                          <img alt="Icon Journey" src={IconJourney} className="inline-block mr-4" />
                        </Suspense>{' '}
                        Minhas jornadas
                      </a>
                    </li>
                    <li className="text-[#18181B] text-xl font-bold">
                      <a href={'/perfil/notificacoes'}>
                        <Suspense fallback={<SkeletonLoading />}>
                          <img alt="Icon Notific" src={IconNotific} className="inline-block mr-4" />
                        </Suspense>
                        Notificações
                      </a>
                    </li>
                    <li className="text-[#18181B] text-xl font-bold mt-12">
                      <button className="btn" id="signoutPerfilInterno">
                        <Suspense fallback={<SkeletonLoading />}>
                          <img alt="Icon Logout" src={IconLogout} className="inline-block mr-4" />
                        </Suspense>
                        Sair
                      </button>
                    </li>
                  </ul>
                </>
                <div className=" w-full ml-auto right-1">
                  <h6 className="text-center text-black opacity-70 font-bold text-2xl mt-10">
                    glemO nas redes
                  </h6>
                  <div className="grid grid-cols-4 mt-0 pt-5 gap-8 w-[max-content] m-auto">
                    <div className="m-auto">
                      <Suspense fallback={<SkeletonLoading />}>
                        <img alt="Logo do Facebook" src={Facebook} className="m-auto" />
                      </Suspense>
                    </div>
                    <div className="m-auto">
                      <Suspense fallback={<SkeletonLoading />}>
                        <img alt="Logo do Linkedin" src={Linkedin} className="m-auto" />
                      </Suspense>
                    </div>
                    <div className="m-auto">
                      <Suspense fallback={<SkeletonLoading />}>
                        <img alt="Logo do Instagram" src={Instagram} className="m-auto" />
                      </Suspense>
                    </div>
                    <div className="m-auto">
                      <Suspense fallback={<SkeletonLoading />}>
                        <img alt="Logo do Youtube" src={Youtube} className="m-auto" />
                      </Suspense>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  )
}
